module.exports = __webpack_public_path__ + "media/images/social/envelope-regular-154e35f06140ddb2d07fea47218a37e8.svg";